<template>
  <v-container
    grid-list-md
    fluid
    v-if="$auth.user().acesso_interno == 'dev' || $auth.user().acesso_interno == 'admin'"
  >
    <!--Index-->
    <v-layout row wrap>
      <v-flex xs12 lg6>
        <v-layout row wrap>
          <v-flex xs12 md9>
            <span class="display-1">
              {{
                this.translate("system.title.consult") +
                this.translate("table." + this.entity + ".title")[1]
              }}
              de Sistema
            </span>
          </v-flex>
          <v-flex xs12 md3 class="text-xs-right">
            <v-btn
              color="primary"
              @click="add('sistema')"
              :disabled="!hasAccess(entity, 'create')"
              class="mb-4 text-xs-right"
            >
              {{ this.translate("system.button.add.title") }}
              <v-icon dark>{{ this.translate("system.button.add.icon") }}</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs12>
            <v-data-table
              :headers="headers"
              :items="items.filter((item) => item.tipo == 'sistema')"
              class="elevation-1"
              :rows-per-page-items="[100, 50, 25, { text: 'Todos', value: -1 }]"
              rows-per-page-text="Registros por página"
              no-data-text="Não existem registros"
              no-results-text="Nenhum registro encontrado"
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.id_texto }}</td>
                <td>{{ props.item.descricao }}</td>
                <td align="center">
                  <v-btn
                    icon
                    class="mx-0"
                    @click="edit('sistema', props.item)"
                    :disabled="!hasAccess(entity, 'update')"
                  >
                    <v-icon color="teal">edit</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="mx-0"
                    @click="deleteItem(props.item)"
                    :disabled="!hasAccess(entity, 'delete')"
                  >
                    <v-icon color="pink">delete</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 lg6>
        <v-layout row wrap>
          <v-flex xs12 md9>
            <span class="display-1">
              {{
                this.translate("system.title.consult") +
                this.translate("table." + this.entity + ".title")[1]
              }}
              de Condomínio
            </span>
          </v-flex>
          <v-flex xs12 md3 class="text-xs-right">
            <v-btn
              color="primary"
              @click="add('condominio')"
              :disabled="!hasAccess(entity, 'create')"
              class="mb-4 text-xs-right"
            >
              {{ this.translate("system.button.add.title") }}
              <v-icon dark>{{ this.translate("system.button.add.icon") }}</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs12>
            <v-data-table
              :headers="headers"
              :items="items.filter((item) => item.tipo == 'condominio')"
              class="elevation-1"
              :rows-per-page-items="[100, 50, 25, { text: 'Todos', value: -1 }]"
              rows-per-page-text="Registros por página"
              no-data-text="Não existem registros"
              no-results-text="Nenhum registro encontrado"
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.id_texto }}</td>
                <td>{{ props.item.descricao }}</td>
                <td align="center">
                  <v-btn
                    icon
                    class="mx-0"
                    @click="edit('condominio', props.item)"
                    :disabled="!hasAccess(entity, 'update')"
                  >
                    <v-icon color="teal">edit</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="
                      !(
                        props.item.tipo == 'condominio' &&
                        props.item.id_texto == 'Visualização, Adição, Edição e Exclusão'
                      )
                    "
                    icon
                    class="mx-0"
                    @click="deleteItem(props.item)"
                    :disabled="!hasAccess(entity, 'delete')"
                  >
                    <v-icon color="pink">delete</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="1600px" persistent>
      <v-card>
        <v-card-text>
          <v-container grid-list-md fluid>
            <v-layout wrap justify-center align-center>
              <v-flex xs12>
                <span class="display-1">
                  {{ formTitle }}
                  {{ editedItem.tipo == "sistema" ? "de Sistema" : "de Condomínio" }}
                </span>
              </v-flex>

              <v-flex xs12 md6>
                <v-text-field
                  maxlength="190"
                  counter="190"
                  ref="autofocus"
                  :label="translate('table.' + entity + '.field.id_texto')"
                  type="text"
                  v-model="editedItem.id_texto"
                />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  :label="translate('table.' + entity + '.field.descricao')"
                  type="text"
                  maxlength="190"
                  counter="190"
                  v-model="editedItem.descricao"
                />
              </v-flex>

              <v-flex xs12>
                <v-data-table
                  :items="permissoes"
                  :headers="
                    editedItem.tipo == 'sistema'
                      ? permissions_sistema_headers
                      : permissions_condominio_headers
                  "
                  class="elevation-1"
                  :rows-per-page-items="[100, 50, 25, { text: 'Todos', value: -1 }]"
                  rows-per-page-text="Registros por página"
                  no-data-text="Não existem registros"
                  no-results-text="Nenhum registro encontrado"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.id_texto }}</td>
                    <td>
                      <v-checkbox v-model="props.item.read" color="primary"></v-checkbox>
                    </td>
                    <td>
                      <v-checkbox
                        v-model="props.item.create"
                        color="primary"
                        v-if="props.item.key != 'suporte'"
                      ></v-checkbox>
                    </td>
                    <td>
                      <v-checkbox
                        v-model="props.item.update"
                        color="primary"
                        v-if="props.item.key != 'suporte'"
                      ></v-checkbox>
                    </td>
                    <td>
                      <v-checkbox
                        v-model="props.item.delete"
                        color="primary"
                        v-if="props.item.key != 'suporte'"
                      ></v-checkbox>
                    </td>
                    <td>
                      <v-checkbox
                        v-model="props.item.enabled"
                        color="primary"
                        v-if="['pessoa', 'condominio', 'contribuinte'].includes(props.item.key)"
                      ></v-checkbox>
                    </td>
                    <td>
                      <v-checkbox
                        v-model="props.item.dbk"
                        color="primary"
                        v-if="['pessoa', 'contribuinte'].includes(props.item.key)"
                      ></v-checkbox>
                    </td>
                    <!-- <td>
                      <v-checkbox
                        v-model="props.item.import"
                        color="primary"
                        v-if="['pessoa'].includes(props.item.key)"
                      ></v-checkbox>
                    </td>
                    <td>
                      <v-checkbox
                        v-model="props.item.export"
                        color="primary"
                        v-if="['pessoa', 'contribuinte'].includes(props.item.key)"
                      ></v-checkbox>
                    </td> -->
                  </template>
                  <template slot="pageText" slot-scope="props">
                    {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
                  </template>
                </v-data-table>
              </v-flex>

              <v-flex xs12>
                <v-btn class="mx-1" color="primary darken-2" :disabled="saving" :loading="saving" @click.native="save()">Salvar</v-btn>
                <v-btn class="mx-1" @click.native="close(400)">Cancelar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
tr td:last-child {
  min-width: 130px;
}

.fab-container {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 10;
}
</style>

<script>
/* eslint-disable camelcase */
import crud from "./../../mixin/crud";
import acl from "./../../mixin/acl";
import routes from "./../../router/index";

// Sempre que adicionar um novo filho nos condomínios, adicionar respectivamenteseu entity neste array
const condominio_filhos = [
  "condominio_pessoa",
  "condominio_transacao",
  "condominio_bemdireito",
  "condominio_bemdireitorural",
  "condominio_dividaonus",
  "condominio_dividaonusrural",
  "condominio_rendimentorecebidopj",
  "condominio_rendimentoisento",
  "condominio_rendimentotributacao",
  "condominio_rendimentoacumuladamente",
  "condominio_pagamento",
  "condominio_imovelexplorado",
  "condominio_movimentacaofinanceira",
  "condominio_movimentacaorebanho",
  "condominio_users",
  "condominio_controlecaixa",
];

export default {
  mixins: [crud, acl],
  data: () => ({
    entity: "acesso",
    tab: null,
    fab: null,
    permissoes: [],
    permissoes_padroes: {},
  }),
  created() {
    this.editedItem = { empresa_id: this.$auth.user().empresa_id };
    this.defaultItem = { empresa_id: this.$auth.user().empresa_id };

    this.permissoes_padroes.sistema = routes.options.routes[1].children.map((item) => ({
      id_texto: item.meta.title,
      key: item.path.substr(1),
      read: false,
      create: false,
      update: false,
      delete: false,
      enabled: false,
      import: false,
      export: false,
    }));
    this.permissoes_padroes.condominio = condominio_filhos.map((id_texto) => ({
      id_texto: this.translate(`table.${id_texto}.title`)[0],
      key: id_texto,
      read: false,
      create: false,
      update: false,
      delete: false,
      enabled: false,
      import: false,
      export: false,
    }));

    this.initialize();
  },
  methods: {
    add(tipo = "sistema") {
      this.editedItem.tipo = tipo;
      this.permissoes = this.permissoes_padroes[tipo];

      this.permissoes = this.permissoes.map((item) => ({
        id_texto: item.id_texto,
        key: item.key,
        read: false,
        create: false,
        update: false,
        delete: false,
      }));

      this.create();
    },
    edit(tipo = "sistema", item) {
      let permissoes = JSON.parse(item.permissoes);
      var permissoes_padroes = JSON.parse(JSON.stringify(this.permissoes_padroes[tipo]));

      this.permissoes = this.$root.merge(permissoes_padroes, permissoes, "id_texto");

      this.editItem(item);
    },
    beforeSave() {
      this.editedItem.permissoes = JSON.stringify(this.permissoes);
    },
  },
  computed: {
    headers: function () {
      return [
        {
          text: this.translate("table." + this.entity + ".field.id_texto"),
          value: "id_texto",
        },
        {
          text: this.translate("table." + this.entity + ".field.descricao"),
          value: "descricao",
        },
        {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
        },
      ];
    },
    permissions_sistema_headers() {
      let array = [
        {
          text: "Tela",
          value: "name",
          align: "center",
        },
        {
          text: "Consultar",
          value: "read",
          align: "center",
        },
        {
          text: "Incluir",
          value: "create",
          align: "center",
        },
        {
          text: "Editar",
          value: "update",
          align: "center",
        },
        {
          text: "Excluir",
          value: "delete",
          align: "center",
        },
        {
          text: "Ativar",
          value: "enabled",
          align: "center",
        },
        {
          text: "Emitir DBK",
          value: "dbk",
          align: "center",
        },
        // {
        //   text: "Importar",
        //   value: "import",
        //   align: "center",
        // },
        // {
        //   text: "Exportar",
        //   value: "export",
        //   align: "center",
        // },
      ];

      return array;
    },
    permissions_condominio_headers() {
      let array = [
        {
          text: "Tela",
          value: "name",
          align: "center",
        },
        {
          text: "Consultar",
          value: "read",
          align: "center",
        },
        {
          text: "Incluir",
          value: "create",
          align: "center",
        },
        {
          text: "Editar",
          value: "update",
          align: "center",
        },
        {
          text: "Excluir",
          value: "delete",
          align: "center",
        },
      ];

      return array;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/crud/Acesso.vue